<script setup lang="ts"></script>

<template>
  <div class="sc-skeletons">
    <div class="sc-skeleton" />
    <div class="sc-skeleton" />
    <div class="sc-skeleton" />
  </div>
</template>

<style lang="scss" scoped>
@use '@inkline/inkline/css/mixins' as *;
@use '@/assets/styles/mixins/skeleton' as skeleton;

.sc-skeletons {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;

  @include breakpoint-down('lg') {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(3, auto);
  }

  .sc-skeleton {
    @include skeleton.skeleton;
    border-radius: 2px;

    &:nth-child(1) {
      width: 100px;
      height: 12px;
      justify-self: start;
    }
    &:nth-child(2) {
      width: 260px;
      height: 58px;
    }
    &:nth-child(3) {
      width: 320px;
      height: 36px;
      justify-self: end;
    }

    @include breakpoint-down('lg') {
      &:nth-child(1) {
        justify-self: center;
        margin-top: 6px;
        margin-bottom: 42px;
      }
      &:nth-child(2) {
        justify-self: center;
        margin-bottom: 56px;
      }
      &:nth-child(3) {
        justify-self: center;
      }
    }
  }
}
</style>
